import { Card } from "react-bootstrap";
import styles from "./ProfileCard.module.scss";
import { User } from "../../../models/user";
import { formatDate } from "../../../utils/formatDate";
import { useTranslation } from "react-i18next";

interface ProfileCardProps {
  user: User;
  rank: number;
  badgeCount: number;
  collectibleCount: number;
}

const ProfileCard = ({ user, rank, badgeCount, collectibleCount }: ProfileCardProps) => {
  const { t, i18n } = useTranslation();
  const currentXpInLevel = user.xp - user.currentLevelMinXp;
  const levelXpRange = user.currentLevelMaxXp - user.currentLevelMinXp;
  const progressPercent = Math.floor((currentXpInLevel / levelXpRange) * 100);

  return (
    <div className={`${styles.topMargin}`}>
      <div className={`center-content ${styles.cardWrapper}`}>
        <div className={styles.imageWrapper}>
          <img
            src={`${process.env.REACT_APP_API_URL}/images/collectibles/profileImages/${user.activeProfileImage}`}
            alt={`${user.activeProfileImage}`}
            className={styles.profileImage}
          />
          <img
            src="/images/decors/profile-border.svg"
            alt="Profile Border"
            className={styles.profileBorder}
          />
        </div>

        <Card
          className={`${styles.profileCard}`}
          style={{
            backgroundImage: `url(${process.env.REACT_APP_API_URL}/images/collectibles/cardThemes/${user.activeCardTheme})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <h2 className={styles.userName}>{user.userName}</h2>

          <div className={styles.progressContainer}>
            <div
              className={styles.progressBar}
              style={{ width: `${progressPercent}%` }}
            ></div>
            <div className={styles.progressText}>
              {user.xp} / {user.currentLevelMaxXp} XP
            </div>
          </div>

          <div className={styles.userStatsTable}>
            <table className={styles.table}>
              <tbody>
                <tr className={styles.tableRow}>
                  <td className={styles.tableCell}>{t('profile.level')}</td>
                  <td className={styles.tableCell}>{t('profile.rank')}</td>
                  <td className={styles.tableCell}>{t('profile.streak')}</td>
                  <td className={styles.tableCell}>{t('profile.badges')}</td>
                  <td className={styles.tableCell}>{t('profile.collectibles')}</td>
                  <td className={styles.tableCell}>{t('profile.signedUp')}</td>
                </tr>
                <tr className={styles.tableRow}>
                  <td className={styles.tableCell}>{user.level}</td>
                  <td className={styles.tableCell}>{rank}</td>
                  <td className={styles.tableCell}>{user.streak}</td>
                  <td className={styles.tableCell}>{badgeCount}</td>
                  <td className={styles.tableCell}>{collectibleCount}</td>
                  <td className={styles.tableCell}>
                    {formatDate(user.signUpDate, i18n.language)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ProfileCard;
